import type { Step } from "react-joyride";

export const userPageTourSteps: Step[] = [
  {
    target: "#profile-header-box",
    content:
      "Welcome to your personal dashboard! Manage all your details here.",
    placement: "bottom",
    title: "Profile Hub",
    disableBeacon: true,
  },
  {
    target: "#profile-avatar-container",
    content: "Click the edit icon to upload a new profile photo.",
    placement: "bottom",
    title: "Avatar",
  },
  {
    target: "#integrations-section",
    content: "Connect external tools like Zoom here.",
    placement: "top",
    title: "Integrations",
  },
];
